import React, { Component } from 'react';
import { Container, Button, Row, Col, ListGroup, Table } from 'react-bootstrap';
import { withRouter, Link } from 'react-router-dom';
import withFetch from '../../hocs/withFetch';
import withUser from '../../hocs/withUser';
import FormByKey from '../../ui/FormByKey/form';
import { _returnFields } from '../../ui/FormByKey/defaultFields';
import { keysToIgnore } from './';
import WarningModal from '../../ui/WarningModal';

export default 
@withRouter
@withUser()
@withFetch((props) => {
    return props.user && props.user ? ({
        inspector: {
            url: `/domoreport/uploader/inspector/${props.match.params.id}`,

        },
        inspectorFields: {
            url: '/domoreport/uploader/inspector/fields',

        },
        updateInspector: (data) => ({
            updatedInspector: {
                url: `/domoreport/uploader/inspector/${props.match.params.id}`,
                method: 'PUT',

                body: JSON.stringify(data)
            }
        }),
        refetchInspector: () => ({
            inspector: {
                url: `/domoreport/uploader/inspector/${props.match.params.id}`,
                force: true,
                refreshing: true,
                headers: {
                    authorization: props.user.token
                }
            }
        }),
        deleteInspector: () => ({
            deletedInspector: {
                url: `/domoreport/uploader/inspector/${props.match.params.id}`,
                method: 'DELETE',
                headers: {
                    authorization: props.user.token
                }
            }
        })

    }) : null;
})
class EditInspectorComponent extends Component {

    state = {
        createWarningOpen: false,
    }

    constructor(props) {
        super(props)
        this._goBack = this._goBack.bind(this);
    }

    _handleChange = (key, value) => {
        console.log('key :', key, value);
        this.setState({ [key]: value });
    }

    _toggleWarningModal = () => {
        const { createWarningOpen } = this.state;
        this.setState({ createWarningOpen: !createWarningOpen }, () => {
            console.log(this.state);
        });
    }

    _onSubmit = () => {
        const { updateInspector, refetchInspector } = this.props;
        console.log('on submit', this.state);
        updateInspector(this.state)
        refetchInspector();
    }

    _onDelete = () => {
        const { deleteInspector } = this.props;
        console.log("Gonna delete this, probably")
        deleteInspector();
        this._goBack();
    }

    _goBack() {
        this.props.history.goBack();
    }

    render() {
        const { inspector, inspectorFields } = this.props;
        const { createWarningOpen } = this.state;
        if (!inspector) {
            return null;
        }
        if (inspector.pending || inspectorFields.pending) {
            return <Container>
                <h2>inspector</h2>
                <Link to="/inspectors">Go Back</Link>
            </Container>
        }

        let { value } = inspector;
        let { value: fields } = inspectorFields;
        let fieldsHash = {}
        fieldsHash = fields.reduce((map, obj) => {
            fieldsHash[obj.Field] = obj.Field
            return fieldsHash;
        });

        if (!this.state.fromServer) {
            this.setState({ ...value, fromServer: !this.state.fromServer })
        }

        let buttonDisabled = false
        for (let key in value) {
            if (value.hasOwnProperty(key)) {
                value[key] = (key in this.state ? this.state[key] : value[key])
                if (!(key in keysToIgnore) && key in fieldsHash) {
                    buttonDisabled = buttonDisabled || value[key] === "" || value[key] === "null" || value[key] === null
                }
            }
        }

        return (
            <div className="md-scroll-wrapper">
                <Container>
                    <Row>
                        <Col>
                            <h2>inspector</h2>
                            <Link to="/inspectors">Go Back</Link>
                            <FormByKey
                                fields={fields}
                                obj={value}
                                onChange={this._handleChange}
                                submit={this._onSubmit}
                                showDelete={true}
                                delete={this._onDelete}
                                returnFields={_returnFields}
                                keysToIgnore={keysToIgnore}
                                disabled={buttonDisabled}

                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm="9"></Col>
                        <Col sm="3">
                            < Button variant="danger" onClick={this._toggleWarningModal}>DELETE</Button>
                        </Col>
                    </Row>
                    <Row style={{ height: 25 }}></Row>
                    {createWarningOpen && <WarningModal
                        close={this._toggleWarningModal}
                        delete={this._onDelete}
                        titleLable={"I'm begging, please don't do this to me"}
                        bodyLable={"I'm too young to die. I've barely started at this life, I can change..."}
                        buttonLable={"Bang"}
                    />}
                </Container>
            </div>
        )
    }
}